import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import { object, string } from 'yup';
import { useNavigate } from 'react-router-dom';
import { AiFillEyeInvisible, AiFillEye } from 'react-icons/ai';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Header from '../../header/header';
import LabelInput from '../../uiComponent/inputs/labelInput';
import Button from '../../uiComponent/button/index';

import { AuthWrapper } from '../style';

import { SignIn as UserSignIn, GetCurrentUser } from '../../../slices/auth';
import { storeToken } from './utils';
import { notification } from 'antd';
import { STORAGE_KEY } from '../../../constants/onBoarding';
import { PERMISSION_MAP } from '../../../constants/routes';
// import ReCAPTCHA from "react-google-recaptcha";

const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { signInLoading } = useSelector(state => state?.auth || {});
  // const [captchaValue, setCaptchaValue] = useState(true);
  // const [resetCaptcha, setResetCaptcha] = useState('');
  // const onChange = (token) => {
  //   let value = token? false: true;
  //   setCaptchaValue(value);
  // };
  
  const [passwordShow, setPasswordShow] = useState(true);

  const handleSetPassword = () => {
    setPasswordShow(!passwordShow);
  };

  const permissionRedirection = (permissions = [], roleId) => {
    const sellerRedirectionPriority = [
      { module: 'inventory', path: '/inventory/sku' },
      { module: 'purchasing', path: '/po-history' },
      { module: 'logistics', path: '/work-orders' },
      { module: 'fileHistory', path: '/file-upload-history' },
      { module: 'settings', path: '/account' }
    ];

    const warehouseRedirectionPriority = [
      { module: 'dashboard', path: '/dashboard' },
      { module: 'purchasing', path: '/po-warehouse' },
      { module: 'logistics', path: '/warehouse-work-orders' },
      { module: 'location', path: '/warehouse-location' },
      { module: 'fileHistory', path: '/file-upload-history' },
      { module: 'clients', path: '/clients' },
      { module: 'settings', path: '/account' }
    ];

    const sellerPlusWarehouseRedirectionPriority = [
      { module: 'dashboard', path: '/dashboard' },
      { module: 'inventory', path: '/inventory/sku' },
      { module: 'purchasing', path: '/po-history' },
      { module: 'logistics', path: '/work-orders' },
      { module: 'location', path: '/warehouse-location' },
      { module: 'fileHistory', path: '/file-upload-history' },
      { module: 'clients', path: '/clients' },
      { module: 'settings', path: '/account' }
    ];

    // Map permission IDs to module names
    const userModules = permissions.map(p => PERMISSION_MAP[p]).filter(Boolean);

    let redirectionPriority = [];

    switch (roleId) {
      case 2: // Seller
        redirectionPriority = sellerRedirectionPriority;
        break;
      case 3: // Warehouse
        redirectionPriority = warehouseRedirectionPriority;
        break;
      case 5: // Seller + Warehouse
        redirectionPriority = sellerPlusWarehouseRedirectionPriority;
        break;
      default:
        return '/access-denied';
    }

    // Find the first available route the user has permission for
    for (const { module, path } of redirectionPriority) {
      if (userModules.includes(module)) {
        return path;
      }
    }

    // Default fallback if no matching permission found
    return '/access-denied';
  };


  const signIn = async(data) => {
    const { email, password } = data;
    const user = {
      email,
      password
    };
    const response = await dispatch(UserSignIn({user}));
    if(!response.error) {
      const { jwt, current_user } = response?.payload?.data || {};
      if(jwt) {
        storeToken(jwt, navigate, dispatch);
        if(!current_user.is_employee_of){
          if (current_user?.role?.id === 3) {
            navigate('/warehouse-location');
          } else {
            navigate('/inventory/sku');
          }
        }
        else{
          navigate(permissionRedirection(current_user.permissions, current_user.role.id));
        }
        // await dispatch(GetCurrentUser());
      }
    } else {
      notification.error({
        message: 'Sign In Error',
        description: response?.payload?.message,
        top: 65
      });
    }
    
    // resetCaptcha.reset();
    // setCaptchaValue(true);
  }; 

  const schema = object().shape({
    email: string().email('Invalid Email').required('Enter your email!'),
    password: string().required('Enter your password')
  });

  return (
    <AuthWrapper>
      <Formik
      validationSchema={schema}
      onSubmit={(values) => signIn(values)}
      initialValues={{
        email: '',
        password: ''
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        errors,
        touched
      }) => (
      <Form onSubmit={handleSubmit}>
      <Header login={false} />
          <div className="auth-container-overlay-wrapper">
          <div className="auth-container">
            <div className="bg-albaster py-40">
              <div>
                <div className="mb-35">
                  <h2>Enter your Registered Email Address</h2>
                </div>
                <LabelInput
                  className="mb-3"
                  name='email'
                  value={values.email}
                  inputStatus={touched.email && errors.email}
                  label="Email" 
                  placeholder="Your  Email" 
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <div className="password-input">
                  <LabelInput
                    className="mb-3"
                    marginBottom="4px"
                    name='password'
                    value={values.password}
                    inputStatus={touched.password && errors.password}
                    label="Password"
                    type={passwordShow ? 'password' : 'text'}
                    placeholder="Password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {passwordShow ? (
                    <AiFillEyeInvisible onClick={handleSetPassword} />
                  ) : (
                    <AiFillEye onClick={handleSetPassword} />
                  )}
                </div>
                <div className="text-end mb-4">
                      <Link to="/auth/forget-password" className="url-link">Forgot Password</Link>
                </div>
                {/* <div className="mb-20 handle-recaptcha" >
                  <ReCAPTCHA
                    ref={e => setResetCaptcha(e)}
                    name='captcha'
                    sitekey={process.env.RECAPTCHA_SITE_KEY}
                    onChange={onChange}
                    onBlur={handleBlur}
                  />
                </div> */}
                <Button
                  loading={true}
                  disabled={signInLoading}
                  type='submit'
                  text={signInLoading? 'Signing In...': 'Sign In'}
                  className="primary w-100"
                />
                {/* {
                  window.innerWidth > 768 && (
                    <div className="text-center mt-3">
                      <span className="text-muted">Don't have an account? </span>
                      <Link
                        to="/auth/sign-up"
                        className="url-link"
                        onClick={() => localStorage.setItem(STORAGE_KEY, JSON.stringify({ "currentStep": 1, "maxStep": 1 }))}
                      >
                        Sign Up Now
                      </Link>
                    </div>
                  )
                } */}

              </div>
            </div>
            </div>
            </div>
      </Form>
      )}
    </Formik>
    </AuthWrapper>
  );
};

export default SignIn;
